import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) 1 e 2 são verdadeiras",
    correct: false,
  },
  {
    option: "b) 3 e 4 são verdadeiras",
    correct: false,
  },
  {
    option: "c) 2 e 4 são verdadeiras",
    correct: true,
  },
  {
    option: "d) Todas são verdadeiras",
    correct: false,
  },
];

export default function Question1(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question1: {
          title:
            "Sobre Marketing Digital, quais são as afirmativas verdadeiras:",
          option: option.option,
          correct: option.correct,
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        Sobre Marketing Digital, quais são as afirmativas verdadeiras:
        <div style={{ textAlign: "left", marginTop: 30 }}>
          <p>
            1 - Independente da abertura dos e-mails, quanto mais enviar FUP,
            melhor, pois o foco em Marketing Digital é quantidade e não
            qualidade
          </p>
          <p>
            2 - Marketing Digital pode auxiliar a levar as mensagens da
            Boehringer para clientes que não estão em nosso alcance fisicamente,
            seja por barreiras geográficas, ou outros impeditivos
          </p>
          <p>
            3 - Marketing Digital é equivalente e se limita a fazer disparo de
            e-mail marketing
          </p>
          <p>
            4 - O website Referência Científica pode ser uma importante
            ferramenta complementar do trabalho de campo, compartilhando vídeos,
            artigos, notícias e demais informações aos nossos clientes.
          </p>
        </div>
      </h5>

      <div className="div-options-question-boe">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-boe ${
              optionSelected === e.option && "selected-option-question-boe"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
